// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Translation/styles.css
// module id = 1909
// module chunks = 193